import {CSSProperties, FC} from 'react';


export interface IIconLocationProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconLocation: FC<IIconLocationProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="m6.2 6.274 2.865 10.002 2.456-4.9 4.553-1.817-9.873-3.285ZM4.533 4.021l15.191 5.052a.404.404 0 0 1 .023.756l-7.055 2.816-3.574 7.132a.403.403 0 0 1-.75-.07L4.015 4.514a.402.402 0 0 1 .517-.492Z" />
        </svg>
    );
};
